import React, { useState } from "react";
import Grid from "@mui/material/Grid2";
import { Select, MenuItem, Switch, TextField, FormControlLabel, Button, Checkbox, ListItemText, InputLabel, FormControl } from "@mui/material";
import { getAuth } from "firebase/auth";
import callApi from "../common/APIClient"

const initialConfig = {
  pipelineName: '', 
  stages: {
    preprocessing: { grayscale: false, denoise: false, resize: true },
    ocr: { enabled: false, psm: 6, language: "en", engine: "Tesseract,EasyOCR" },
    classification: { enabled: false, model: "BERT,BART", labels: "invoice,medical_record,prescription" },
    ner: { enabled: false, model: "BERT,BART" },
    postprocessing: { custom_rules: "", regex_cleaning: false }
  },
  variables: { classification_threshold: 0.9, confidence_threshold: 0.85, ner_threshold: 0.8, max_pages: 10 }
};

const DynamicPipelineUI = () => {
  const [config, setConfig] = useState(initialConfig);
  const [selectedStages, setSelectedStages] = useState([]);
  const [selectedFields, setSelectedFields] = useState({});

  const handlePipelineNameChange = (e) => {
    setConfig(prev => ({
      ...prev,
      pipelineName: e.target.value,
    }));
  };

  const handleStageSelect = (event) => {
    setSelectedStages(event.target.value);
  };

  const handleToggle = (stage, key) => {
    setSelectedFields(prev => ({
      ...prev,
      [stage]: {
        ...prev[stage],
        [key]: !prev[stage]?.[key]
      }
    }));
  };

  const handleChange = (stage, key, value) => {
    setSelectedFields(prev => ({
      ...prev,
      [stage]: {
        ...prev[stage],
        [key]: value
      }
    }));
  }; 

  const handleSave = async () => {
    const savedConfig = { stages: {} };
    savedConfig.pipelineName = config.pipelineName
    selectedStages.forEach(stage => {
      if (selectedFields[stage]) {
        savedConfig.stages[stage] = selectedFields[stage];
      }
    });
    console.log(savedConfig);

    try {
      const auth = getAuth();
      const user = auth.currentUser;
      if (!user) return;
      const token = await user.getIdToken();
      
      const response = await callApi({
        url: "/pipeline/" + savedConfig.pipelineName,
        method: "POST",
        data: savedConfig,
        headers: {
          Authorization: `Bearer ${token}`,
        }
      });

      const msg = response.message;
      const pipelineId = response.pipeline_id;
      console.log("Pipeline Created: pipelineId: " + pipelineId);
      console.log("Pipeline Created: msg: " + msg);
      console.log("Server Response:", response);
    } catch (error) {
      console.error("Processing Document error:", error);
    } finally {
      
    }
  };

  return (
    <div style={{ padding: 20 }}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            label="Pipeline Name"
            value={config.pipelineName}
            onChange={handlePipelineNameChange}
            fullWidth
            margin="dense"
          />
        </Grid>
        <Grid item xs={6}>
          <FormControl fullWidth sx={{minWidth: 300}}>
            <InputLabel>Select Stages</InputLabel>
            <Select
              multiple
              value={selectedStages}
              onChange={handleStageSelect}
              displayEmpty
              renderValue={(selected) =>
                selected.length ? selected.join(", ") : "Select Stages"
              }
            >
              {Object.keys(config.stages).map(stage => (
                <MenuItem key={stage} value={stage}>
                  <Checkbox checked={selectedStages.includes(stage)} />
                  <ListItemText primary={stage.toLocaleUpperCase()} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          </Grid>
      </Grid>

      {selectedStages.map(stage => (
        <div key={stage} style={{ marginTop: 20, borderBottom: "1px solid #ddd", paddingBottom: 10 }}>
          <h3>{stage}</h3>
          <Grid container spacing={2}>
            {Object.keys(config.stages[stage]).map((key) => {
              const value = selectedFields[stage]?.[key] ?? config.stages[stage][key];
              return typeof value === "boolean" ? (
                <Grid item xs={12} key={key}>
                  <FormControlLabel
                    control={<Switch checked={value} onChange={() => handleToggle(stage, key)} />}
                    label={key}
                  />
                </Grid>
              ) : typeof value === "string" && value.includes(",") ? (
                <Grid item xs={6} key={key}>
                  <FormControl fullWidth sx={{minWidth: 300}}>
                    <InputLabel>{key}</InputLabel>
                    <Select
                      value={value}
                      onChange={(e) => handleChange(stage, key, e.target.value)}
                    >
                      {value.split(",").map((option) => (
                        <MenuItem key={option} value={option}>{option}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              ) : (
                <Grid item xs={6} key={key}>
                  <TextField
                    label={key}
                    value={value}
                    onChange={e => handleChange(stage, key, e.target.value)}
                    fullWidth
                    margin="dense"
                  />
                </Grid>
              );
            })}
          </Grid>
        </div>
      ))}
      <Button variant="contained" color="primary" onClick={handleSave} style={{ marginTop: 20 }}>Save Config</Button>
    </div>
  );
};

export default DynamicPipelineUI;
